import { CSSProperties } from 'react';

const VideoIcon = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.22949 4.99984C8.22949 3.21642 6.78375 1.77068 5.00033 1.77068C3.21691 1.77068 1.77117 3.21642 1.77117 4.99984C1.77117 6.78326 3.21691 8.229 5.00033 8.229C6.78375 8.229 8.22949 6.78326 8.22949 4.99984ZM9.27117 4.99984C9.27117 7.35856 7.35905 9.27068 5.00033 9.27068C2.64161 9.27068 0.729492 7.35856 0.729492 4.99984C0.729492 2.64113 2.64161 0.729004 5.00033 0.729004C7.35905 0.729004 9.27117 2.64113 9.27117 4.99984Z"
      fill="white"
    />
    <path
      d="M4.32292 3.8271C4.48407 3.73406 4.68262 3.73407 4.84376 3.82711L6.09376 4.54881C6.2549 4.64185 6.35417 4.81379 6.35417 4.99986C6.35417 5.18593 6.2549 5.35787 6.09376 5.45091L4.84376 6.17263C4.68262 6.26567 4.48407 6.26567 4.32292 6.17263C4.16178 6.07959 4.0625 5.90765 4.0625 5.72158V4.27816C4.0625 4.09208 4.16178 3.92013 4.32292 3.8271Z"
      fill="white"
    />
  </svg>
);

const ThreeDots = ({
  activeIndex,
  imagesCount,
  mediaTypes
}: {
  activeIndex: number;
  imagesCount: number;
  mediaTypes?: ('photo' | 'video')[];
}) => {
  if (imagesCount <= 1) {
    return null;
  }

  const dotItems = Array.from({ length: imagesCount }, (_, i) => i);

  return (
    <div style={containerStyle}>
      {dotItems.map((index) => (
        <div
          key={index}
          style={{
            ...itemStyle,
            opacity: index === activeIndex ? 1 : 0.5
          }}
        >
          {mediaTypes?.[index] === 'video' ? (
            <VideoIcon />
          ) : (
            <div style={dotStyle} />
          )}
        </div>
      ))}
    </div>
  );
};

const containerStyle: CSSProperties = {
  position: 'absolute',
  right: '50%',
  transform: 'translateX(50%)',
  top: '15px',
  zIndex: 3,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '7px',
  height: '18px',
  backgroundColor: 'rgba(0, 0, 0, 0.2)',
  padding: '0 5px',
  borderRadius: '20px'
};

const itemStyle: CSSProperties = {
  width: '10px',
  height: '10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

const dotStyle: CSSProperties = {
  width: '8px',
  height: '8px',
  borderRadius: '50%',
  backgroundColor: 'white'
};

export default ThreeDots;
